export const firebaseConfig = {
  apiKey: "AIzaSyBsRZZgJVa78hvpGBhgHtiIJ99BaxoDXaE",
  authDomain: "rayyan-h-tafe-nsw-2.firebaseapp.com",
  projectId: "rayyan-h-tafe-nsw-2",
  storageBucket: "rayyan-h-tafe-nsw-2.appspot.com",
  messagingSenderId: "63137248093",
  appId: "1:63137248093:web:ef978bcd80e8993c31aeb4"
}
